import { Link } from "react-router-dom";

interface SectionTitleProps {
  eyebrow?: boolean;
  title: string;
  to?: string;
  linkLabel?: string;
}

export default function SectionTitle({ eyebrow, title, to, linkLabel = "查看全部" }: SectionTitleProps) {
  return (
    <div className="mb-6 flex items-end justify-between border-b border-background-300 pb-3">
      <div className="flex items-center gap-3">
        {eyebrow && (
          <span className="hidden h-9 w-1.5 shrink-0 rounded-full bg-accent-400 sm:block" aria-hidden />
        )}
        <h2 className="font-serif text-xl font-black tracking-tight text-foreground-950 md:text-2xl">
          {title}
        </h2>
      </div>
      {to && (
        <Link
          to={to}
          className="inline-flex shrink-0 cursor-pointer items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
        >
          {linkLabel}
          <i className="ri-arrow-right-line" />
        </Link>
      )}
    </div>
  );
}